import { AxiosError } from "axios";

const catchError = <T, E extends new (message?: string) => Error>(
  promise: Promise<T>,
  errorTypes?: E[],
): Promise<[undefined, T] | [InstanceType<E>]> => {
  return promise
    .then((data) => [undefined, data] as [undefined, T])
    .catch((error) => {
      if (!errorTypes) return [error];
      if (errorTypes.some((ErrorType) => error instanceof ErrorType)) {
        return [error];
      }
      throw error;
    });
};

const catchAxiosError = <T>(
  promise: Promise<T>,
): Promise<[undefined, T] | [AxiosError]> => {
  return catchError(promise, [AxiosError]);
};

export { catchAxiosError, catchError };
